export const pageRoute : {[key:string] : string} = {
  Training: '/training',
  Progress: '/progress',
  Club: '/club',
  Profile: '/profile',
};
